import React, { useEffect, useState } from 'react'
import {
  CCard,
  CCardHeader,
  CCardBody,
  CFormLabel,
  CForm,
  CLoadingButton,
  CRow,
  CFormInput,
  CCol,
  CFormSwitch,
  CFormSelect,
} from '@coreui/react-pro'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import CommonService from 'src/service/CommonService'
import ToastComponent from 'src/components/common/TaostComponent'
import InputRange from 'react-input-range'
import 'react-input-range/lib/css/index.css'
const GamePrivacy = (props) => {
  const [loader, setLoader] = useState(false)
  const [showCode, setShowCode] = useState(false)
  const formik = useFormik({
    initialValues: {
      privacy: props.gameprivacy,
    },
    enableReinitialize: true,
    // validationSchema,
    onSubmit: (data, actions) => {
      setLoader(true)
      CommonService.updateGamePrivacy(data)
        .then((res) => {
          if (res.status === 200) {
            // Assuming your API returns full game object in res.data
            props.setGamePrivacy(res.data.game_privacy) // update privacy
            props.setGameData(res.data) // update gameData too
            ToastComponent(res.message, 'success')
          } else {
            ToastComponent(res.message, 'error')
          }
          setLoader(false)
        })
        .catch((e) => {
          console.log('Here is Error', e)
          setLoader(false)
        })
    },
  })
  const handleChange = (event) => {
    setShowCode(event.target.value)
  }

  if (props.bare) {
    return (
      <>
        <CCol md={12} xs={12}>
          {!props.hideDescription && (
            <CFormLabel className="" htmlFor="name">
              {
                "Default visibility of the game is set as 'Public'. You can make the game 'Private' below. If privacy is set as 'Private', all members will be required to enter the unique game code to join the game."
              }
            </CFormLabel>
          )}
          <CFormSelect
            aria-label="Select Privacy"
            name="privacy"
            className="form-control"
            value={props.value}
            onChange={(event) => props.onChange(event.target.value)}
          >
            <option value="1">Public</option>
            <option value="2">Private</option>
          </CFormSelect>
        </CCol>
        <CCol md={12} xs={12}>
          {props.value == 2 && (
            <span className="mt-3"> Code: {props.gameData.game_accept_code}</span>
          )}
        </CCol>
      </>
    )
  }

  return (
    <>
      <br></br>
      <CForm className="row" onSubmit={formik.handleSubmit}>
        <CRow className="">
          <CCol md={12} xs={12}>
            <CFormLabel className="" htmlFor="name">
              {
                "Default visibility of the game is set as 'Public'. You can make the game 'Private' below. If privacy is set as 'Private', all members will be required to enter the unique game code to join the game."
              }
            </CFormLabel>
            <CFormSelect
              aria-label="Select Privacy"
              name="privacy"
              className={
                ' form-control' +
                (formik.errors.privacy && formik.touched.privacy ? ' is-invalid' : '')
              }
              value={formik.values.privacy}
              onChange={(event) => {
                formik.setFieldValue('privacy', event.target.value)
              }}
            >
              <option value="1">Public</option>
              <option value="2">Private</option>
            </CFormSelect>
          </CCol>
          <CCol md={12} xs={12} className="mt-3">
            {props.gameprivacy == 2 && (
              <span className="mt-3"> Code: {props.gameData.game_accept_code}</span>
            )}
          </CCol>
        </CRow>

        <CCol md={6}>
          <CLoadingButton type="submit" color="success" variant="outline" loading={loader}>
            Submit
          </CLoadingButton>
        </CCol>
      </CForm>
    </>
  )
}

export default GamePrivacy
